import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AuthContext } from './AuthContext';
import './AdminLayout.css';

const AdminLayout = ({ children }) => {
  const { user } = useContext(AuthContext);
  const location = useLocation();

  if (!user || user.role !== 'admin') {
    return <div>Accesso negato</div>;
  }

  const menuItems = [
    { path: '/admin/vendors', label: 'Venditori' },
    { path: '/admin/customers', label: 'Clienti' },
    { path: '/admin/merchant-connections', label:'Merchant Esterni' },
    { path: '/admin/loverlist-css', label: 'Pagine CSS' },
    { path: '/admin/merchant-accounts', label: 'Merchant Interni' },
    { path: '/admin/google-ads-spending', label: 'Spesa Google Ads' },
    { path: '/admin/billing-overview', label: 'Overview Billing' },
    { path: '/admin/transactions-invoices', label: 'Transazioni e Fatture' }
  ];

  return (
    <>
      <nav className="admin-menu">
        <div className="admin-menu-container">
          <div className="admin-menu-header">
            <h2>Admin Panel</h2>
          </div>
          <div className="admin-menu-items">
            {menuItems.map(item => (
              <Link
                key={item.path}
                to={item.path}
                className={`admin-menu-item ${location.pathname === item.path ? 'active' : ''}`}
              >
                <span className="admin-menu-label">{item.label}</span>
              </Link>
            ))}
          </div>
        </div>
      </nav>
      <div className="admin-page-container">
        <div className="admin-content-wrapper">
          {children}
        </div>
      </div>
    </>
  );
};

export default AdminLayout; 